module.exports = __webpack_public_path__ + "img/meshwell.86e6123d.png";